<template>
  <div id="weblog">
    <div id="navbar">
      <img
        src="../public/favicon.png"
        alt="webblog"
        srcset=""
        title="ckstocks.com"
        id="logo"
        @dblclick="checkforcklogin"
      />
    </div>

    <router-view></router-view>
    <!-- <div id="buymeacoffee"></div> -->
    <div id="footer">
      <a
        class="first"
        href="https://www.ckstocks.com"
        target="_blank"
        rel="noreferrer"
        >&copy; ckstocks.com</a
      >
      <a href="mailto:contact@ckstocks.com" target="_blank"
        ><i class="fa fa-envelope fa-lg" aria-hidden="true"></i
      ></a>
      <a href="https://twitter.com/ichandragangani?s=09" target="_blank"
        ><i
          class="fa fa-twitter fa-lg"
          aria-hidden="true"
          style="color: #1da1f2"
        ></i
      ></a>
      <a
        class="last"
        href="https://www.youtube.com/channel/UCvyO6k5Nyocm40yblnB8tYQ"
        target="_blank"
        ><i
          class="fa fa-lg fa-youtube-play"
          aria-hidden="true"
          style="color: #ff0000"
        ></i
      ></a>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
Vue.use(VueToast);

export default {
  name: "App",
  props: ["username"],
  data() {
    return {
      loggedIn: true,
    };
  },

  methods: {
    checkforcklogin() {
      if (!this.$route.params.title) {
        var password = prompt("www.ckstocks.com");
        if (password != "Ckpgangani77") {
          Vue.$toast.open({
            message: "Sorry....",
            type: "error",
            position: "top",
            duration: 1000,
          });
        } else {
          this.$router.replace({ path: "newpost" });
        }
      } else if (String(this.$route.path).includes("updatepost")) {
        Vue.$toast.open({
          message: "Update it ",
          type: "info",
          position: "bottom-left",
        });
      } else {
        var pass = prompt("www.ckstocks.com");
        if (pass != "Ckpgangani77") {
          Vue.$toast.open({
            message: "Sorry....",
            type: "error",
            position: "top",
            duration: 1000,
          });
        } else {
          var updatedpath = "updatepost/" + this.$route.params.title;
          this.$router.replace({ path: updatedpath });
        }
      }
    },
  },
};
</script>

<style scoped>
#logo {
  width: 60px;
  height: auto;
  /* margin-top: -35px; */
}
.router-link-exact-active {
  color: white !important;
}
#weblog {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  user-select: none;
  margin-top: 40px;
}
#navbar {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: space-evenly;
  color: rgb(255, 255, 255) !important;
  -webkit-backdrop-filter: saturate(180%) blur(10px);
  backdrop-filter: saturate(180%) blur(10px);
  padding: 5px;
  height: 33px;
  z-index: 111;
}

#navbar :first-child {
  float: left;
  font-size: 25px;
  font-weight: 600;
}
.navoption {
  text-decoration: none;
  text-align: center;
  color: rgba(255, 255, 255, 0.836) !important;
  font-size: large;
  padding: 5px;
  transition: 0.4s;
  border-radius: 5px;
}
.navoption:hover {
  color: white !important;
}
.logoutbtn {
  background: transparent;
  outline: none;
  border: none;
  border-radius: 5px;
  font-size: 10px;
  transition: 0.4s;
  font-weight: 700;
  margin-bottom: 5px;
  color: rgba(255, 255, 255, 0.836) !important;
}
.logoutbtn:hover {
  color: white;
}

#footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  margin: 0;
  padding: 5px;
  color: rgba(255, 255, 255, 0.836);
  -webkit-backdrop-filter: saturate(180%) blur(10px);
  backdrop-filter: saturate(180%) blur(10px);
  display: flex;
  justify-content: flex-end;
}

#footer a {
  color: rgba(255, 255, 255, 0.836);
  margin-right: 10px;
  transition: 0.2s;
}
#footer .last {
  margin-right: 30px;
}

#footer .first {
  margin-right: 38%;
}
@keyframes Enteranimation {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

@media screen and (max-width: 650px) {
  #footer a {
    font-size: 9px;
  }
}
</style>
